import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import ThemeIcons from '../../theme/Icons';

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-family: 'Roboto',"Helvetica Neue",'Arial',"Noto Sans","Liberation Sans",sans-serif;
`;

const Message = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
  margin-top: 8px;
`;

const SubText = styled.div`
  font-size: 14px;
  color: #888;
  line-height: 1.5;
  font-weight: 600;
`;

const ErrorScreen = ({ schemaError }) => {
  return (
    <Wrapper>
      <Icon icon={ThemeIcons.misc.exclamation} size="2xl" />
      <Message>{schemaError.message}</Message>
      <SubText>
        {schemaError.code}
      </SubText>
      <SubText>
        SDK Version:
        {' '}
        {schemaError.details.sdkVersion}
      </SubText>
      <SubText>
        Schema Version:
        {' '}
        {schemaError.details.schemaVersion}
      </SubText>
    </Wrapper>
  );
};

export default ErrorScreen;
